import heroBackground from '../../assets/background/IMG_8370.webp';
import HeroBanner, { hexToRgbList } from '../../page_assets/HeroBanner';

// The flat field IMG_8370 is painted on, sampled off the photo itself.
const FIELD = '#E12D39';

// The same red the header takes its fill from over this landing — see page_assets/header.
export const FIELD_RGB = hexToRgbList(FIELD);

/**
 * The home landing. Everything about how it behaves is HeroBanner's; what's here is this
 * page's own photo, palette and copy. The title is left to inherit the page's colour,
 * since the name is the one of the three that isn't set in a colour of its own.
 */
export default function HeroSection() {
    return (
        <HeroBanner
            backgroundImage={heroBackground}
            field={FIELD}
            ink="#F7DB00"
            title={{ script: 'bao', text: 'Catherine', syllables: ['Cat', 'her', 'ine'] }}
            heading="Computational Behavioral Modeling"
            body="I graduated from the University of Utah with a honors degree in Computer Science, where I researched computational
                cognitive psychology and natural language processing. Specialized in behavioral research, marketing, and design.
                My work spans four leading research universities, where I have studied human behavior modeling, computational
                cognitive psychology, and natural language processing."
        />
    );
}
